<template>
    <v-list nav dense>
        <template v-for="node in menu">
            <!-- Enlace directo -->
            <v-list-item v-if="!node.children" :key="node.key" link router :to="node.to" class="list"
                active-class="white black--text">
                <v-list-item-action>
                    <v-icon>{{ node.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ node.tkey ? $t(node.tkey) : node.label }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <!-- Carpeta -->
            <v-list-group v-else :key="node.key" :prepend-icon="node.icon" no-action color="white" class="menu-group">
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title>{{ node.tkey ? $t(node.tkey) : node.label }}</v-list-item-title>
                    </v-list-item-content>
                </template>

                <template v-for="child in node.children">
                    <!-- Enlace dentro de carpeta -->
                    <v-list-item v-if="!child.children" :key="child.key" link router :to="child.to" class="list"
                        active-class="white black--text">
                        <v-list-item-action>
                            <v-icon>{{ child.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ child.tkey ? $t(child.tkey) : child.label }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <!-- Subcarpeta -->
                    <v-list-group v-else :key="child.key" sub-group no-action color="white">
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>{{ child.tkey ? $t(child.tkey) : child.label }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item v-for="leaf in child.children" :key="leaf.key" link router :to="leaf.to"
                            class="list" active-class="white black--text">
                            <v-list-item-action>
                                <v-icon>{{ leaf.icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ leaf.tkey ? $t(leaf.tkey) : leaf.label }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                </template>
            </v-list-group>
        </template>

        <div v-if="loadingAreas" class="text-center py-2">
            <v-progress-circular indeterminate color="white" size="20"></v-progress-circular>
        </div>
    </v-list>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { mapGetters, mapState } from 'vuex'

const API_BASE_URL = 'https://clubtest.intrare.app'

export default {
  name: 'admin',
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language']),
    menu () {
      const p = this.getProfile || {}
      const only = (cond, items) => (cond ? items : [])
      const link = (key, icon, to, extra = {}) => ({ key, icon, to, ...extra })
      const group = (key, icon, children, extra = {}) => ({ key, icon, children: children.filter(Boolean), ...extra })

      const areaGroup = this.areas.length
        ? group('areas-dyn', 'mdi-map-marker-radius', this.areas.map(a =>
          group('area-' + a.id, 'mdi-map-marker', [
            link('area-' + a.id + '-checkin', 'mdi-account-check', `/sports-area/${a.id}/checkin`, { tkey: 'checkin_checkout' })
          ], { label: a.name })
        ), { tkey: 'Areas' })
        : null

      const nodes = [
        link('home', 'mdi-home', '/home', { tkey: 'Inicio' }),

        group('admin', 'mdi-briefcase', [
          group('admin-residents', 'mdi-home-city', [
            link('houses', 'mdi-home-variant', '/casas', { tkey: 'casas' }),
            link('main-residents', 'mdi-account-star', '/main_residents', { tkey: 'main_residents' }),
            link('directory', 'mdi-bookmark-box-multiple', '/directory', { tkey: 'directory' })
          ], { label: 'Residentes' }),
          group('admin-staff', 'mdi-account-group', [
            link('staff', 'mdi-face-agent', '/staff', { label: 'Staff' }),
            ...only(p.staff === true, [link('department', 'mdi-account-group', '/department_manager', { tkey: 'department_manager' })]),
            link('workers', 'mdi-badge-account', '/workers_admin', { tkey: 'workers' }),
            link('guards', 'mdi-clipboard-account', '/guards', { tkey: 'Vigilantes' })
          ], { label: 'Personal' }),
          group('admin-finance', 'mdi-cash-multiple', [
            link('accounts', 'mdi-account-cash', '/account_statements', { tkey: 'account_statements' }),
            link('financial', 'mdi-finance', '/financial_statements', { tkey: 'financial_statements' })
          ], { label: 'Finanzas' }),
          link('areas', 'mdi-domain', '/areas', { tkey: 'Areas' }),
          link('guardhouses', 'mdi-store-24-hour', '/guardhouses', { tkey: 'Casetas' })
        ], { tkey: 'Administración' }),

        group('comms', 'mdi-bullhorn', [
          link('notices', 'mdi-bullhorn', '/notices', { tkey: 'Notices' }),
          ...only(this.canManageEvents, [link('club-events', 'mdi-calendar-star', '/admin/club-events', { tkey: 'ce_title' })]),
          ...only(this.canApproveInvitations, [link('inv-approvals', 'mdi-email-check-outline', '/admin/invitation-approvals', { tkey: 'invitation_approvals' })])
        ], { label: 'Comunicación' }),

        group('sports', 'mdi-football', [
          ...only(this.canManageGym, [link('gym', 'mdi-dumbbell', '/gym', { label: 'Gimnasio' })]),
          link('courts', 'mdi-soccer-field', '/courts', { tkey: 'courts' }),
          link('sports', 'mdi-football', '/sports', { tkey: 'sports' }),
          link('schedules', 'mdi-calendar-range', '/sports_schedules', { tkey: 'sports_schedules' }),
          link('booking', 'mdi-clipboard-text-clock', '/reservation', { tkey: 'booking' })
        ], { tkey: 'Deportes' }),

        areaGroup,

        group('golf', 'mdi-golf', [
          group('golf-ops', 'mdi-flag-variant', [
            link('caddies', 'mdi-account-tie', '/golf/caddies', { tkey: 'golf_caddies' }),
            link('golf-courts', 'mdi-soccer-field', '/golf/courts', { tkey: 'golf_courts' }),
            link('caddie-house', 'mdi-package-variant', '/golf/caddie-house', { label: 'Caddie House' }),
            link('garage', 'mdi-car', '/golf/garage', { label: 'Garaje de Carritos' })
          ], { label: 'Operación' }),
          group('golf-players', 'mdi-account-multiple', [
            link('reservations', 'mdi-calendar-clock', '/golf/reservations', { tkey: 'golf_reservations' }),
            link('scorecards', 'mdi-chart-line', '/golf/scorecards', { label: 'Scorecards' }),
            link('handicaps', 'mdi-calculator', '/golf/handicaps', { label: 'Handicaps' }),
            link('players-summary', 'mdi-account-multiple', '/golf/players-summary', { label: 'Resumen de Jugadores' }),
            link('blacklist', 'mdi-account-cancel', '/golf/blacklist', { tkey: 'golf_blacklist' })
          ], { label: 'Jugadores' }),
          link('tournaments', 'mdi-tournament', '/golf/tournaments', { label: 'Torneos' }),
          group('marshall', 'mdi-shield-account', [
            link('outings', 'mdi-clock-outline', '/golf/marshall/outings', { label: 'Salidas del Día' }),
            link('starter-order', 'mdi-golf-tee', '/golf/marshall/starter-order', { label: 'Orden de Salida' }),
            link('warnings', 'mdi-alert-octagon', '/golf/marshall/warnings', { label: 'Amonestaciones' })
          ], { label: 'Marshall' }),
          group('academy', 'mdi-school', [
            link('academy-home', 'mdi-view-dashboard', '/academy', { label: 'Panel Principal' }),
            link('academy-teachers', 'mdi-account-tie', '/academy/teachers', { label: 'Profesores' }),
            link('academy-clinics', 'mdi-calendar-clock', '/academy/clinics', { label: 'Clínicas' }),
            link('academy-students', 'mdi-account-multiple', '/academy/students', { label: 'Alumnos' })
          ], { label: 'Academia' })
        ], { label: 'Golf' }),

        group('records', 'mdi-book-open-page-variant', [
          link('historical', 'mdi-book-open-page-variant', '/historical', { tkey: 'Historial' }),
          ...only(p.idHousingUnit === '2c34ad01-90f3-4540-9263-33707827cbcf',
            [link('historical-adv', 'mdi-book-search', '/historical_no_code', { tkey: 'Historial_avanzado' })]),
          ...only(p.enable_parcel === true, [link('parcel', 'mdi-truck', '/parcel', { tkey: 'parcel' })]),
          ...only(p.enable_reports === true, [link('reports', 'mdi-alert', '/reports', { tkey: 'Reports' })])
        ], { label: 'Registros' }),

        link('settings', 'mdi-cog-outline', '/settings', { tkey: 'configuracion' }),
        link('help', 'mdi-help-circle', '/ayuda', { tkey: 'Ayuda' })
      ]
      return nodes.filter(Boolean)
    },
    canManageEvents () {
      const profile = this.getProfile || {}
      const permissions = profile.permissions
      return profile.staff === true ||
        (Array.isArray(permissions) && (permissions.includes('starter') || permissions.includes('events_admin')))
    },
    canManageGym () {
      const profile = this.getProfile || {}
      const permissions = profile.permissions
      return profile.staff === true ||
        (Array.isArray(permissions) && (permissions.includes('fitness_admin') || permissions.includes('fitness_coach')))
    },
    canApproveInvitations () {
      const permissions = this.getProfile && this.getProfile.permissions
      return this.getProfile.invitations_require_approval ||
        (Array.isArray(permissions) && permissions.includes('starter'))
    }
  },
  data: () => ({
    areas: [],
    loadingAreas: false
  }),
  created () {
    this.loadAreas()
  },
  methods: {
    async loadAreas () {
      this.loadingAreas = true
      try {
        const response = await axios({
          method: 'get',
          url: `${API_BASE_URL}/area/`,
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          }
        })
        const allAreas = response.data || []
        // Filter ONLY Gimnasio and Natacion/Alberca as requested
        this.areas = allAreas.filter(a => {
          const name = (a.name || '').toLowerCase()
          return name.includes('gimnasio') || name.includes('nataci') || name.includes('alberca') || name.includes('piscina') || name.includes('gym')
        })
      } catch (error) {
        console.error('Error loading areas:', error)
      } finally {
        this.loadingAreas = false
      }
    }
  }
}
</script>

<style scoped>
/* Items del menú con imagen de fondo */
.list {
    margin: 2px 8px !important;
    border-radius: 8px !important;
    transition: all 0.2s ease;
}

.list:hover {
    background: rgba(255, 255, 255, 0.15) !important;
}

/* Carpetas/grupos del menú */
.menu-group {
    margin: 4px 8px !important;
    border-radius: 8px !important;
}

.menu-group:hover {
    background: rgba(255, 255, 255, 0.1) !important;
}
</style>

<style>
/* Estilos para el menú con imagen de fondo */
.v-navigation-drawer .v-list-item__title {
    color: #ffffff !important;
    font-weight: 500 !important;
    font-size: 0.9rem !important;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.9) !important;
    white-space: nowrap !important;
    overflow: visible !important;
}

.v-navigation-drawer .v-list-item__subtitle {
    color: rgba(255, 255, 255, 0.85) !important;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7) !important;
}

/* Iconos blancos SIN sombra */
.v-navigation-drawer .v-icon {
    color: #ffffff !important;
}

.v-navigation-drawer .v-list-item:hover .v-icon {
    color: #4fc3f7 !important;
}

.v-navigation-drawer .v-list-group__header:hover {
    background: rgba(255, 255, 255, 0.1) !important;
}

.v-navigation-drawer .v-list-item:hover {
    background: rgba(255, 255, 255, 0.15) !important;
}

/* Título del nombre del usuario */
.v-navigation-drawer .title {
    color: #ffffff !important;
    font-weight: 600 !important;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8) !important;
}

/* Divisor sutil */
.v-navigation-drawer .v-divider {
    border-color: rgba(255, 255, 255, 0.2) !important;
}

/* Item activo */
.v-navigation-drawer .v-list-item--active {
    background: rgba(255, 255, 255, 0.2) !important;
}

/* Reducir padding en items del submenú para más espacio de texto */
.v-navigation-drawer .v-list-group__items .v-list-item {
    padding-left: 40px !important;
    min-height: 40px !important;
}

.v-navigation-drawer .v-list-group__items .v-list-item__action {
    margin-right: 16px !important;
    min-width: 24px !important;
}

.v-navigation-drawer .v-list-group__items .v-list-item__action .v-icon {
    font-size: 20px !important;
}

/* Asegurar que el texto no se corte */
.v-navigation-drawer .v-list-item__content {
    overflow: visible !important;
}

/* Estilos para cuando el drawer está semi-cerrado (mini-variant) */
.v-navigation-drawer--mini-variant .v-list-item {
    justify-content: center !important;
    padding: 0 8px !important;
}

.v-navigation-drawer--mini-variant .v-list-item__action {
    margin: 0 !important;
    min-width: auto !important;
}

.v-navigation-drawer--mini-variant .v-list-item--active {
    background: rgba(255, 255, 255, 0.25) !important;
    border-radius: 8px !important;
    margin: 2px 6px !important;
}

.v-navigation-drawer--mini-variant .v-list-item:hover {
    background: rgba(255, 255, 255, 0.15) !important;
    border-radius: 8px !important;
    margin: 2px 6px !important;
}

.v-navigation-drawer--mini-variant .v-list-group__header {
    justify-content: center !important;
    padding: 0 8px !important;
}

.v-navigation-drawer--mini-variant .v-list-group__header:hover {
    background: rgba(255, 255, 255, 0.15) !important;
    border-radius: 8px !important;
    margin: 2px 6px !important;
}

</style>
